var render, staticRenderFns
import script from "./baseValidacionTelefono.vue?vue&type=script&lang=js"
export * from "./baseValidacionTelefono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7741a4c8')) {
      api.createRecord('7741a4c8', component.options)
    } else {
      api.reload('7741a4c8', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Formularios/validacionSMS/baseValidacionTelefono.vue"
export default component.exports